<template>
    <div>
      <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card class="text-center">
  
          <v-card-title>
            <v-spacer />
            <v-icon @click="notConfirmed">mdi-close</v-icon>
          </v-card-title>
  
          <v-card-text v-if="transaction">
  
            <v-alert v-if="error" border="left" color="error" dark dismissible>
              {{ error }}
            </v-alert>
  
            <v-icon color="success" size="50">
              mdi-check-outline
            </v-icon>
  
            <h2 class="text--primary mt-3">CONFIRMATION</h2>
  
            <p class="pt-5 font-weight-medium">
              Voulez-vous vraiment accepter cette Transaction ?
            </p>
  
        
  
            <v-row>
              <v-col>
                <v-btn class="rounded-lg mt-4" color="success" depressed large @click="[confirm()]" :loading="btnLoading">
                  <v-icon left>mdi-check-circle-outline</v-icon>
                  Confirmer mon action
                </v-btn>
              </v-col>
  
            </v-row>
  
  
  
  
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { HTTP } from "@/http-common";
  
  export default {
    data() {
      return {
        dialog: false,
        is_confirm: false,
        confirm_dialog: false,
        transaction: null,
        btnLoading: false,
        error: "",
      };
    },
    methods: {
      open(transaction) {
        this.error = "";
        this.transaction = transaction;

  
        this.dialog = true;
      },
      confirm() {
        this.error = "";
        this.btnLoading = true;
  
        HTTP.post( "v1/support/accept_refill/"+
          this.transaction.id)
          .then(() => {
            this.btnLoading = false;
            this.dialog = false;
            this.$successMessage = "Transaction acceptée";
            this.$emit("refresh");
            this.$store.dispatch("fetchAccount");
          })
          .catch((err) => {
            console.log(err);
            this.btnLoading = false;
  
            if (err.response.data.success === false) {
              this.error = "Impossible d'accepter cette Transaction";
            }
          });
      },
      notConfirmed() {
        this.dialog = false;
      },
    },
  
    computed: {
      
    },
  };
  </script>